export default function DetailLocalBox({ local }) {
  return (
    <div style={{ marginTop: '10px', marginBottom: '20px' }}>
      <div style={{ marginBottom: '5px' }}>
        <b>Estado:</b>
        <span style={{ marginLeft: '10px' }}>
          {' '}
          {local?.estado}
        </span>
      </div>
      <div style={{ marginBottom: '5px' }}>
        <b>Municipio:</b>
        <span style={{ marginLeft: '10px' }}>
          {' '}
          {local?.cidade}
        </span>
      </div>
    </div>
  );
}
